// controls/staticText.js
import React, { useState, useEffect } from "react";
import CommonControls from "./inc/Common";
import { BiText, BiEdit } from "react-icons/bi";
import TipTapEditor from "./../../../helpers/TipTapEditor/TipTapEditor";

import "./staticText.css";

/**
 * Création du bloc de texte statique
 */
export function createStaticTextField() {
  return {
    type: "object",
    title: "Bloc de texte",
    "x-ui": "staticText",
    "x-static": true,
    content: "Texte d’exemple…",
    hiddenInSummary: false,
  };
}

/**
 * Éditeur du bloc texte (admin / form builder)
 */
export function EditStaticTextField({ field, onChange }) {
  const [content, setContent] = useState(field.content || "");
  const [hiddenInSummary, setHiddenInSummary] = useState(
    !!field.hiddenInSummary
  );
  const [showModal, setShowModal] = useState(false);

  // 🔄 synchro vers le parent (schema)
  useEffect(() => {
    onChange({
      ...field,
      content,
      hiddenInSummary,
    });
  }, [content, hiddenInSummary]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      {/* Aperçu du contenu */}
      <div className="mb-3">
        <label className="form-label fw-bold d-flex align-items-center gap-2">
          <BiText size={18} /> Contenu du bloc
        </label>

        <div
          className="border rounded p-2 bg-light small mb-2"
          style={{ minHeight: 60 }}
        >
          {content ? (
            <div
              className="text-truncate"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ) : (
            <span className="text-muted">Aucun contenu</span>
          )}
        </div>

        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={() => setShowModal(true)}
        >
          <BiEdit className="me-1" />
          Modifier le texte
        </button>
      </div>

      {/* Option résumé */}
      <div className="mb-3 form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id={`hidden-summary-${field.id || "static-text"}`}
          checked={hiddenInSummary}
          onChange={(e) => setHiddenInSummary(e.target.checked)}
        />
        <label
          className="form-check-label"
          htmlFor={`hidden-summary-${field.id || "static-text"}`}
        >
          Masquer ce bloc dans le résumé
        </label>
      </div>

      {/* ---- MODALE Bootstrap 5 ---- */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,.5)" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title">
                  Modifier le contenu du bloc
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                  aria-label="Fermer"
                />
              </div>

              <div className="modal-body">
                <TipTapEditor
                  key={field.id || "static-text"}
                  value={content}
                  onChange={setContent}
                  minHeight={200}
                />
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Fermer
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setShowModal(false)}
                >
                  Enregistrer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export const editStaticTextField = (props) => (
  <EditStaticTextField {...props} />
);
/* =========================================================
   🧩 FRONT — rendu du bloc statique texte
   ========================================================= */
export const RenderStaticTextField = ({ field }) => {
  const content = field.content || "";
  const isHTML = /<[a-z][\s\S]*>/i.test(content);

  const nl2br = (text) =>
    text.split("\n").map((line, i) => (
      <React.Fragment key={i}>
        {line}
        <br />
      </React.Fragment>
    ));
  return (
    <div className={`fb-field fb-static-text ${field["x-class"] || ""}`}>
      {content ? (
        isHTML ? (
          <div
            className={field["x-control-class"] || ""}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <div className={field["x-control-class"] || ""}>
            {nl2br(content)}
          </div>
        )
      ) : (
        <p className="text-muted">Aucun texte défini</p>
      )}
    </div>
  );
};
